import { withTranslation } from "react-i18next";

function NotiAccionMessage({t, notificationType, type, status, name_doctor}){

    const textType = type =>{
        let obj = {
            "citaPendiente": "cita pendiente",
            "citaConfirmada": "confirmación de cita",
            "citaRecordatorio": "recordatorio de cita",
            "citaReasignada": "reasignación de cita"
        }

        return obj[type] || ''
    }

    let obj = {
        Creation: `Envío de correo de ${textType(type)}`,
        Cancel: `Envío de correo de cancelación de cita`,
        Document: `Envío de correo de documentos de la cita` ,
        Update: t('ha_modificado_cita'),
        Prescription: 'se ha agregado una nueva receta',
        SMS: `Envío de sms de ${textType(type)}`,
        DoctorNotConnected: `No se ha conectado el médico ${name_doctor} a la cita`,
        Reassigned: `Envío de correo de ${textType(type)} al médico ${name_doctor}`,
    }

    return obj[notificationType] || null
}

export default withTranslation()(NotiAccionMessage)